var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6522 21.5133C33.9765 29.9352 26.585 36.0006 17.9981 36C13.2248 35.9997 8.64716 34.1033 5.27199 30.7281C-0.799855 24.6561 -1.73691 15.1406 3.03389 8.00085C7.80469 0.861123 16.9546 -1.9142 24.8878 1.3722C32.821 4.65859 37.3279 13.0914 35.6522 21.5133ZM32.2328 15.1713C30.8823 8.37974 24.9225 3.48791 17.9981 3.48741C14.1485 3.48713 10.4565 5.01616 7.73426 7.7381C2.83769 12.6342 2.08154 20.3074 5.92823 26.0651C9.77492 31.8228 17.1531 34.0615 23.5506 31.412C29.9481 28.7625 33.5832 21.9628 32.2328 15.1713Z",
    fill: "#D81D5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2002 17.0996H19.8002V27.8996H16.2002V17.0996Z",
    fill: "#D81D5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2002 9H19.8002V12.6H16.2002V9Z",
    fill: "#D81D5D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a8dad72482186d2db72db6a3c8b61b26.svg";
export { ForwardRef as ReactComponent };